import {
	SET_INTERACTION,
	SET_VERSION,
	SET_TEST_MODE,
	SET_TEST_SENT,
	RECOVER_SAVED_STATE,
	RESTART_EXERCISE,
	SET_EX_CONTAINER,
	SET_ITEMS_KEYS,
	MARK_ITEM_WITH_AUDIO,
	SET_BASE_PATH
} from '../actions/types';

const INITIAL_STATE = {
	interaction: null,
	version: null,
	testMode: null,
	testSent: false,
	itemsKeys: [],
	itemsWithAudio: [],
	basePath: null
};

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case SET_BASE_PATH: {
			const newState = { ...state };
			newState.basePath = action.payload;
			return newState;
		}

		case SET_ITEMS_KEYS: {
			const newState = { ...state };
			newState.itemsKeys = action.payload;
			return newState;
		}

		case MARK_ITEM_WITH_AUDIO: {
			const newState = { ...state };
			newState.itemsWithAudio[action.payload] = true;
			return newState;
		}

		case SET_INTERACTION: {
			const newState = { ...state };
			newState.interaction = action.payload;
			return newState;
		}

		case SET_VERSION: {
			const newState = { ...state };
			newState.version = action.payload;
			return newState;
		}

		case SET_TEST_MODE: {
			const newState = { ...state };
			newState.testMode = action.payload;
			return newState;
		}

		case SET_TEST_SENT: {
			const newState = { ...state };
			newState.testSent = true;
			return newState;
		}

		case SET_EX_CONTAINER: {
			const newState = { ...state };
			newState.exContainer = action.payload;
			return newState;
		}

		case RECOVER_SAVED_STATE: {
			const newState = { ...state };
			newState.testSent = action.payload.testSent;
			newState.itemsWithAudio = action.payload.itemsWithAudio;
			return newState;
		}

		case RESTART_EXERCISE: {
			const newState = { ...state };
			newState.testSent = false;
			newState.itemsWithAudio = [];
			return newState;
		}

		default:
			return state;
	}
}
